import { render, staticRenderFns } from "./aboutAs.vue?vue&type=template&id=e1c4afc6&scoped=true&"
var script = {}
import style0 from "./aboutAs.vue?vue&type=style&index=0&id=e1c4afc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c4afc6",
  null
  
)

export default component.exports